import { useContext, useState } from 'react';
import './login-popup.css'
import { Link } from 'react-router-dom';
import { cartContext } from '../../App';

export default function LoginPopUp() {

    const {showPopup, setShowPopUp} = useContext(cartContext);

    function handleClose() {
        setShowPopUp(false);
    }

    return (
        <div className='login-popup-container' style={{ display: `${!showPopup && 'none'}` }}>
            <div className='login-popup-text-box'>
                <p className='login-popup-header'>Enjoy 10% Off in App – Use Code APP10</p>
                <p className='login-popup-text'>Download our app now and enjoy exclusive discounts, lightning-fast checkout, and a smoother shopping journey.</p>
            </div>
            <div className='popup-cross' onClick={handleClose}><img src='/icons/x-mark.png' alt='X' style={{height:'25px', width:'25px'}}/></div>
            <div className='login-popup-box'>
                <img className='login-popup-logo' src='ic_launcher_rounded.png' alt='logo'/>
                <p className='popup-text'>OnTimeUrban App</p>
            </div>
            <Link to='https://play.google.com/store/apps/details?id=com.otu_android' style={{textDecoration: 'none'}}>
                <div className='guest-box'>
                    <img src='google-play-btn.png' alt='play-store' style={{ height: '35px' }} />
                    <p className='login-popup-download-btn'>DOWNLOAD</p>
                </div>
            </Link>
        </div>
    );

}